import { render } from "./ConversationItem.vue?vue&type=template&id=a335f916&scoped=true&lang=pug"
import script from "./ConversationItem.vue?vue&type=script&lang=js"
export * from "./ConversationItem.vue?vue&type=script&lang=js"

import "./ConversationItem.vue?vue&type=style&index=0&id=a335f916&lang=scss&scoped=true"
import "./ConversationItem.vue?vue&type=style&index=1&id=a335f916&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a335f916"]])

export default __exports__